const LogisticRegressionIntro = () => {
    return (
        <div className="max-w-4xl mx-auto px-4">
            <p className="tw-header">Logistic Regression Intro</p>
            <p className="tw-sub-header">
                Logistic Regression is one of the most popular classification algorithms
            </p>
            <hr className="mt-4 mb-4"/>
            <p className="tw-subtitle text-gray-600">
                Logistic Regression is a linear model that uses logistic functions to model the probability of a binary
                outcome. It doesn't necessarily need to be binary, but that is the typical use case.
            </p>
            <br/>
            <p className="tw-subtitle text-gray-600">
                This section revolves around binary classification. There is a separate section for mulitclass
                classification which will dive deeper into that topic.
            </p>
            <br/>
            <p className="tw-subtitle text-gray-600">
                We will discuss logistic regression, how to calculate it's cost function, then how to use this function
                within gradient descent. Where we will be using the respective partial derivatives, which if you have read
                the gradient descent section, then it will look very similar.
            </p>
        </div>
    )
}

export default LogisticRegressionIntro;